import React, { useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { useNetwork } from "../lib/network";

// Full-viewport replacement for the routed app content — rendered by
// NetworkProvider (via App.js) whenever connectivity is confirmed lost.
// Recovery is automatic (NetworkProvider polls in the background); the
// "Try again" button just lets the user force an immediate attempt instead
// of waiting for the next poll tick.
export default function NoInternetScreen() {
  const { retry } = useNetwork();
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    setRetrying(true);
    try { await retry(); } finally { setRetrying(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-5" data-testid="no-internet-screen">
      <div className="bg-white rounded-3xl border border-neutral-200 p-8 text-center max-w-md w-full">
        <div className="w-16 h-16 rounded-3xl bg-brand-clay/10 text-brand-clay flex items-center justify-center mx-auto">
          <WifiOff className="w-8 h-8" strokeWidth={2.2} />
        </div>
        <h2 className="font-heading text-2xl font-extrabold mt-5">No Internet Connection</h2>
        <p className="text-neutral-600 mt-2 leading-relaxed">
          You're offline. We'll reconnect automatically as soon as your connection is back.
        </p>
        <Button
          onClick={handleRetry}
          disabled={retrying}
          className="mt-6 h-14 rounded-2xl bg-brand-sky hover:bg-blue-700 font-bold px-7 w-full"
          data-testid="no-internet-retry-btn"
        >
          <RefreshCw className={`w-4 h-4 mr-2 ${retrying ? "animate-spin" : ""}`} />
          {retrying ? "Checking…" : "Try again"}
        </Button>
      </div>
    </div>
  );
}
